<script setup>
import AppBar from './bars/AppBar.vue'
import SideBar from './bars/SideBar.vue'
import {useUserStore} from "@/plugins/obscore";
import {storeToRefs} from "pinia";

const auth = storeToRefs(useUserStore()).isAuthenticated
</script>
<template>
  <v-app>
    <SideBar app v-if="auth"></SideBar>
    <v-main>
      <v-container fluid class="px-6 h-100">
        <AppBar app v-if="auth"></AppBar>
        <router-view></router-view>
      </v-container>
    </v-main>
  </v-app>
</template>
